// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Switch,
//   Typography,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   CircularProgress,
//   Button
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import Navbar from '../components/Navbar';
// import CustomSelect from '../components/CustomSelect';
// import { api } from '../helpers/apiRequest';
// import { toast } from 'react-toastify';
// import colors from '../theme/Colors';
// import { pageAccessList } from '../helpers/pageAccessList';

// const CustomSwitch = styled(Switch)(() => ({
//   '& .MuiSwitch-switchBase.Mui-checked': {
//     color: '#1abc9c',
//   },
//   '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
//     backgroundColor: '#1abc9c',
//   },
// }));

// const Access = () => {
//   const [users, setUsers] = useState([]);
//   const [selectedCustomer, setSelectedCustomer] = useState('');
//   const [accessControl, setAccessControl] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState('Merchandiser');
//   const [searchTerm, setSearchTerm] = useState();
//   const fetchAccess = async (userId) => {
//     try {
//       setLoading(true);
//       const res = await api.get(`/users/get/routes?userId=${userId}`);
//       const accessArray = res.data.message || [];

//       // Map route permissions by route key
//       const accessMapFromServer = accessArray.reduce((map, item) => {
//         map[item.route] = item.allowed;
//         return map;
//       }, {});

//       // Merge with full pageAccessList to ensure all routes are covered
//       const accessMap = pageAccessList.reduce((acc, page) => {
//         acc[page.key] = accessMapFromServer[page.key] || false;
//         return acc;
//       }, {});

//       setAccessControl(accessMap);
//     } catch (err) {
//       toast.error('Failed to fetch access data');
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleToggle = async (routeKey) => {
//     if (!selectedCustomer) return toast.warn('Select a user first');

//     const allowed = !accessControl[routeKey];
//     setAccessControl((prev) => ({ ...prev, [routeKey]: allowed }));

//     const page = pageAccessList.find(p => p.key === routeKey);
//     const type = page?.type || 'page'; // default fallback to 'page'

//     try {
//       await api.put(`/users/assign/route?userId=${selectedCustomer}`, {
//         route: routeKey,
//         allowed,
//         type, // <- Include type here
//       });
//     } catch (err) {
//       toast.error('Failed to update access');
//     }
//   };

//   const fetchUsers = async () => {
//     setLoading(true);
//     try {
//       let user = await localStorage.getItem('user');
//       user = JSON.parse(user);
//       const queryParams = new URLSearchParams();
//       queryParams.append('page', 1);
//       queryParams.append('limit', 1000);

//       let response;
//       if (searchTerm) {
//         // response = await api(`users/user-search/${searchTerm}?page=${1}&limit=${1000}`);
//       } else {
//         const roleParam = activeTab.toLowerCase() === 'merchandiser' ? 'merchant' : activeTab.toLowerCase();
//         response = await api(`users/users/role/${roleParam}?${queryParams.toString()}`);
//       }

//       if (response.status) {
//         const data = await response.data.data;
//         setUsers(data || []);
//         // setTotalPages(Math.ceil(response?.data?.total_count / rowsPerPage));
//       } else {
//         console.error('Failed to fetch users:', response.statusText);
//       }
//     } catch (error) {
//       console.error('Error fetching users:', error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   useEffect(() => {
//     if (selectedCustomer) {
//       fetchAccess(selectedCustomer);
//     } else {
//       setAccessControl({});
//     }
//   }, [selectedCustomer]);
//   useEffect(() => {
//     fetchUsers();
//   }, [activeTab]);
//   return (
//     <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2 }}>
//       <Navbar title="Access Control" />
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           width: '100%',
//           flexWrap: 'wrap',
//           padding: 2,
//         }}
//       >
//         {['Merchandiser', 'Employee', 'Customer'].map((role) => (
//           <Button
//             key={role}
//             sx={{
//               backgroundColor: activeTab === role ? colors.primary : 'white',
//               color: activeTab === role ? 'white' : colors.primary,
//               borderWidth: 2,
//               borderColor: colors.primary,
//             }}
//             variant={activeTab === role ? 'contained' : 'outlined'}
//             onClick={() => setActiveTab(role)}
//             style={{ margin: 8 }}
//           >
//             {role}
//           </Button>
//         ))}
//       </Box>
//       <Paper sx={{ padding: 2, marginTop: 3 }}>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             marginBottom: 2,
//           }}
//         >
//           <Typography variant="h6">Page Access Settings</Typography>

//           <CustomSelect
//             label="Select a User"
//             value={selectedCustomer}
//             onChange={(e) =>
//               e.target.value !== 'All Users'
//                 ? setSelectedCustomer(e.target.value)
//                 : setSelectedCustomer('')
//             }
//             options={users.map((c) => ({ id: c._id, name: c.name }))}
//             sx={{ minWidth: 200 }}
//           />
//         </Box>

//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//             <CircularProgress />
//           </Box>
//         ) : selectedCustomer ? (
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell><strong>Page</strong></TableCell>
//                 <TableCell align="right"><strong>Allow Access</strong></TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {pageAccessList.map((page) => (
//                 <TableRow key={page.key}>
//                   <TableCell>{page.label}</TableCell>
//                   <TableCell align="right">
//                     <CustomSwitch
//                       checked={!!accessControl[page.key]}
//                       onChange={() => handleToggle(page.key)}
//                     />
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         ) : (
//           <Box sx={{ textAlign: 'center', p: 4 }}>
//             <Typography variant="body1" color="text.secondary">
//               Please select a user from the dropdown to see and modify their access.
//             </Typography>
//           </Box>
//         )}

//       </Paper>
//     </Box>
//   );
// };

// export default Access;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Switch,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  Button,
  useMediaQuery, // Import useMediaQuery hook
  useTheme,      // Import useTheme hook
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Navbar from '../components/Navbar';
import CustomSelect from '../components/CustomSelect';
import { api } from '../helpers/apiRequest';
import { toast } from 'react-toastify';
import colors from '../theme/Colors';
import { pageAccessList } from '../helpers/pageAccessList';

const CustomSwitch = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#1abc9c',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#1abc9c',
  },
}));

const Access = () => {
  const [users, setUsers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [accessControl, setAccessControl] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('Merchandiser');
  const [searchTerm, setSearchTerm] = useState(); // Unused, consider removing if not needed

  // Theme and media query for responsive adjustments
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // true if screen is 'sm' or smaller

  const fetchAccess = async (userId) => {
    try {
      setLoading(true);
      const res = await api.get(`/users/get/routes?userId=${userId}`);
      const accessArray = res.data.message || [];

      const accessMapFromServer = accessArray.reduce((map, item) => {
        map[item.route] = item.allowed;
        return map;
      }, {});

      const accessMap = pageAccessList.reduce((acc, page) => {
        acc[page.key] = accessMapFromServer[page.key] || false;
        return acc;
      }, {});

      setAccessControl(accessMap);
    } catch (err) {
      toast.error('Failed to fetch access data');
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (routeKey) => {
    if (!selectedCustomer) return toast.warn('Select a user first');

    const allowed = !accessControl[routeKey];
    setAccessControl((prev) => ({ ...prev, [routeKey]: allowed }));

    const page = pageAccessList.find(p => p.key === routeKey);
    const type = page?.type || 'page'; // default fallback to 'page'

    try {
      await api.put(`/users/assign/route?userId=${selectedCustomer}`, {
        route: routeKey,
        allowed,
        type,
      });
    } catch (err) {
      toast.error('Failed to update access');
      // Revert the state if API call fails
      setAccessControl((prev) => ({ ...prev, [routeKey]: !allowed }));
    }
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      // let user = await localStorage.getItem('user'); // Unused, consider removing if not needed
      // user = JSON.parse(user); // Unused, consider removing if not needed
      const queryParams = new URLSearchParams();
      queryParams.append('page', 1);
      queryParams.append('limit', 1000);

      let response;
      if (searchTerm) {
        // If searchTerm functionality is needed, uncomment and implement
        // response = await api(`users/user-search/${searchTerm}?page=${1}&limit=${1000}`);
      } else {
        const roleParam = activeTab.toLowerCase() === 'merchandiser' ? 'merchant' : activeTab.toLowerCase();
        response = await api(`users/users/role/${roleParam}?${queryParams.toString()}`);
      }

      if (response && response.status) { // Check if response exists before accessing status
        const data = await response.data.data;
        setUsers(data || []);
      } else {
        // Log error if response status is not successful, or response is undefined
        console.error('Failed to fetch users:', response ? response.statusText : 'No response');
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [activeTab]); // Removed empty dependency array to ensure it runs on tab change

  useEffect(() => {
    if (selectedCustomer) {
      fetchAccess(selectedCustomer);
    } else {
      setAccessControl({});
    }
  }, [selectedCustomer]);

  return (
    <Box
       sx={{
         display: 'flex',
         flexDirection: 'column',
        padding: { xs: 1, sm: 2, md: 3 }, // Responsive padding remains
        width: '95%', // Ensure it takes full available width
       }}
     >
      <Navbar title="Access Control" />

      {/* Role Selection Buttons */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          flexWrap: 'wrap', // Allows buttons to wrap to the next line
          gap: { xs: 1, sm: 2 }, // Gap between buttons, responsive
          padding: { xs: 1, sm: 2 }, // Responsive padding
        }}
      >
        {['Merchandiser', 'Employee', 'Customer'].map((role) => (
          <Button
            key={role}
            sx={{
              backgroundColor: activeTab === role ? colors.primary : 'white',
              color: activeTab === role ? 'white' : colors.primary,
              borderWidth: 2,
              borderColor: colors.primary,
              minWidth: { xs: 'auto', sm: 120 }, // Adjust button width
              padding: { xs: '6px 12px', sm: '8px 16px' }, // Adjust button padding
              fontSize: { xs: '0.75rem', sm: '0.875rem' }, // Adjust font size
            }}
            variant={activeTab === role ? 'contained' : 'outlined'}
            onClick={() => setActiveTab(role)}
          >
            {role}
          </Button>
        ))}
      </Box>

      <Paper sx={{
        padding: { xs: 2, md: 3 }, // Responsive padding for Paper
        marginTop: { xs: 2, md: 3 }, // Responsive margin top
      }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' }, // Stack on small screens, row on larger
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' }, // Align items based on screen size
            marginBottom: 2,
            gap: { xs: 2, sm: 0 }, // Gap when stacked
          }}
        >
          <Typography variant={isSmallScreen ? "h6" : "h5"}>Page Access Settings</Typography> {/* Adjust Typography variant */}

          <CustomSelect
            label="Select a User"
            value={selectedCustomer}
            onChange={(e) =>
              e.target.value !== 'All Users'
                ? setSelectedCustomer(e.target.value)
                : setSelectedCustomer('')
            }
            options={users.map((c) => ({ id: c._id, name: c.name }))}
            sx={{
              minWidth: { xs: '100%', sm: 200 }, // Full width on small, fixed on larger
              marginTop: { xs: 1, sm: 0 }, // Margin when stacked on small screens
            }}
          />
        </Box>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : selectedCustomer ? (
          <Box sx={{ overflowX: 'auto', width: '100%' }}> {/* Makes table horizontally scrollable */}
            <Table sx={{ minWidth: 350 }}> {/* Ensures table has a minimum width */}
              <TableHead>
                <TableRow>
                  <TableCell><strong>Page</strong></TableCell>
                  <TableCell align="right"><strong>Allow Access</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pageAccessList.map((page) => (
                  <TableRow key={page.key}>
                    <TableCell>{page.label}</TableCell>
                    <TableCell align="right">
                      <CustomSwitch
                        checked={!!accessControl[page.key]}
                        onChange={() => handleToggle(page.key)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        ) : (
          <Box sx={{ textAlign: 'center', p: 4 }}>
            <Typography variant="body1" color="text.secondary">
              Please select a user from the dropdown to see and modify their access.
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default Access;
